import {
  MillwrightDaysSinceLastIncident,
  MillwrightDaysSinceLastIncidentApiResponse,
} from '@/apis/incidents/types/incidentsApi';

export const daysSinceLastIncidentFromApiAdapter = (
  workedHours: MillwrightDaysSinceLastIncidentApiResponse,
): MillwrightDaysSinceLastIncident => {
  return {
    empId: workedHours.emp_id ?? 0,
    firstName: workedHours.first_name ?? '',
    lastName: workedHours.last_name ?? '',
    lastIncidentDate: workedHours.last_incident_date ?? '',
    daysSinceLastIncident: workedHours.days_since_last_incident ?? 0,
    riskScore: workedHours?.risk_score ? workedHours.risk_score * 100 : 0,
  };
};
